export enum FuneralStatusType {
  Edit = '編集',
  Showing = '表示',
  End = '終了',
  Cancel = '取消', // New status
}
